import HeaderInput from './Header';
import {headerData, storeyData, opening, defaultMansard, getInitObj} from './data';
import Main from './Main';
import React, {useState, useEffect} from 'react';
import {EscapeElement} from './utils/utils';
import {clGen} from './utils/generalClass';
import {BtnCalc} from './BtnCalc'


let flageType = false;

export default function Notification({picture}) {

const [count, setCount] = useState(headerData);
const [floor, setFloor] = useState(storeyData);
const [result, setResult] = useState({
  dlina: '',
  shirina: '',
  dlinaV: '',
  tolshinaN: setNameArr('tolshinaN'),
  tolshinaV: setNameArr('tolshinaV'),
});
const [resultMansard, setResultMansard] = useState({});
const [validates, setValidates] = useState(false);
const [textBtnAdd, setTextBtnAdd] = useState('этаж');

function setNameArr(names){
  let res = headerData.filter( el => el.name === names);
  return res[0].dropdown[0];
}


const addElementFloor = ({id,internal, outdoor}) => {

 let copy = Object.assign({}, floor.filter( el => el.id === id));
 if (internal) copy[0].internal.defaultFields.push(opening(id))
 if (outdoor) copy[0].outdoor.defaultFields.push(opening(id))


 setFloor([...floor]);

}


// Добавление этажа
const addElement = (e) => {

  if (textBtnAdd === 'этаж') {
    setFloor([...floor, getInitObj()]);
    flageType = false
  } else  {
    setFloor([...floor, defaultMansard()]);
    flageType = true
  }

}

const viewElement = (id, flage) => {
  floor.filter( (el) => {
    if (el.id === id && el.hasOwnProperty('next')){
     flageType = false
    }
  })
  if (flage){
    setFloor(floor.filter( el => {        
        el.outdoor.defaultFields.filter( (elem,index) => {
          if (elem[0].allId === id){
            return el.outdoor.defaultFields.splice(index, 1)
          }
        });
          el.internal.defaultFields.filter( (elem,index) => {
            if (elem[0].allId === id){
              return el.internal.defaultFields.splice(index, 1)
            }
          });

    }));
   
  }
  setFloor(floor.filter( el => el.id !== id));

  updateResult(id, result, setResult);
  updateResult(id, resultMansard, setResultMansard);
  
};


function updateResult(id, arrayResult, argSet){
  const objResult = {};
  for (let key in arrayResult){
    if (key.split("=?=")[2] !== id && key.split("=?=")[1] !== id){
      objResult[key] = arrayResult[key]
    }
  }
  argSet(objResult);
}

const textBtn = (e) => e.target.value === 'all' ? setTextBtnAdd('этаж') : setTextBtnAdd('мансарду');

const validate = (e) => {
  if (!validates) return;
  const arrKey = [];
  for (let key in result){
    if (result[key] === '' || isNaN(result[key])){
      arrKey.push(key)
    }
  }
  return arrKey
}

let resultValidate = validate();


const validateMouse = () => {
  if (!validates) setValidates(true);
}

function removeValueChildren({e, children, drop}){
  if (e.target.closest('select').name === 'children' && drop){
    let obj = {}
    children.forEach( el => {
        obj[el.name] = 0;
    })
   setResult({...result, ...obj});
  }
}

let [resultObjem, objemPer] = [];
if (clGen.calculation(flageType, result) !== undefined){
  [resultObjem, objemPer] = clGen.calculation(flageType, result, resultMansard);
}

  return (
    <div className="container px-5 m-auto mb-[80px]">
        <h1 className="text-center font-bold text-[22px] sm:text-[1.5em] mt-10 leading-8 sm:leading-7">Калькулятор расчета объема газобетонного блока<br/>для строительства</h1>
        <div className="fields-top bg-[#f0f0f0] grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-4 my-5 sm:my-10 shadow-md p-5 sm:p-10 rounded-md">
          {count.map(el => <HeaderInput key={el.id} 
                                        text={el.text} 
                                        id={el.id} 
                                        dropdown={el.dropdown} 
                                        children={el.children} 
                                        value={(e) => clGen.valueField(e, setResult, result, el.id)} 
                                        name={el.name} 
                                        validate={resultValidate}
                                        result={result}
                                        funcResult={removeValueChildren}
                                        />)}
        </div>
        <div className="scrollbarCustom relative rounded-xl overflow-auto">
          <div className={"flex relative w-full gap-6 snap-x overflow-x-auto pb-14 w-max"}>
            {floor.map( (el, index, arr) => {      
                  return <Main key={el.id} 
                                text={el.fields} 
                                id={el.id} 
                                dropdown={el.dropdown} 
                                children={el.children} 
                                outdoor={el.outdoor} 
                                internal={el.internal}
                                floor={addElementFloor}
                                alias={el.alias}
                                view={viewElement}
                                count={floor}
                                index={(flageType && arr.length - 1 === index)   ? 'Мансардный' : index + 1}
                                value={(e) => clGen.valueField(e, setResult, result, el.id, el.next, resultMansard, setResultMansard)} 
                                name={el.name} 
                                validate={resultValidate}
                                result={result}
                                funcResult={removeValueChildren}
                                type={el.type}
                                />            
            })}
          </div>
        </div>

        <div className="flex justify-center w-full fixed bottom-0 left-0">
          <BtnCalc picture={picture} validateMouse={validateMouse} resultValidate={resultValidate} resultObjem={resultObjem}/>
          <div className={(!flageType ? "group " : "pointer-events-none	translate-y-[29px] opacity-40 ") + " transition duration-700 hover:translate-y-[0] justify-center	flex-col items-center flex w-max"}>
            <div className="bg-[#f4dd3a] p-[48px 15px 0 15px] pt-12 pr-6 pl-6 pb-2 relative">
            {
              !flageType ?
              <div className="" onClick={(e) => addElement(e)}> 
                  <div className="right-[-9px] absolute left-0 top-[11px] m-auto flex justify-center items-center" >
                    <EscapeElement color={'#000'} translateY={'50%'} translateX={'50%'} rotate={'45deg'}/>
                  </div>
                  <p>Добавить {textBtnAdd}</p>
              </div> : 
              <div className="" disabled> 
                  <div className="right-[-9px] absolute left-0 top-[11px] m-auto flex justify-center items-center" >
                    <EscapeElement color={'#000'} translateY={'50%'} translateX={'50%'} rotate={'45deg'}/>
                  </div>
                  <p>Добавить {textBtnAdd}</p>
              </div>
            }
          </div>
          <div className="absolute pb-[10px] max-[600px]:group-hover:translate-y-[-98%] sm:group-hover:right-0 sm:group-hover:translate-x-[98%] pl-3 pr-3 w-max translate-y-[0] bg-[#fff] z-[-1] transition duration-700">
            <p>Тип этажа:</p>
            <div>            
              <input className="form-radio 
                            rounded-xl
                            mr-[10px]
                            border-gray-300
                            text-indigo-600
                            shadow-sm
                            focus:border-indigo-300
                            focus:ring
                            focus:ring-offset-0
                            focus:ring-indigo-200
                            focus:ring-opacity-50
                          " type="radio" name="type" value="all" id="all" defaultChecked onClick={textBtn} />
              <label htmlFor="all">Полный</label>
            </div>
            <div>            
              <input className="form-radio 
                            rounded-xl
                            mr-[10px]
                            border-gray-300
                            text-indigo-600
                            shadow-sm
                            focus:border-indigo-300
                            focus:ring
                            focus:ring-offset-0
                            focus:ring-indigo-200
                            focus:ring-opacity-50
                          " type="radio" name="type" value="mansard" id="mansard" onClick={textBtn}/>
                <label htmlFor="mansard">Мансардный</label>
            </div>
            </div>
          
          </div>
        </div>
    </div>
    
  )
}
